export default {
  'Enter a promo code! First limit people receive amount coins':
    'ใส่รหัสโปรโมชัน! คนกลุ่มแรกที่ได้รับเหรียญ',
};
